import React from 'react';

import type { ReportFooterProps } from 'src/components/reports/report-detail/ReportToolbar';
import { ReportFooter } from 'src/components/reports/report-detail/ReportToolbar';

import { ListCountFooter } from '../generic/data-grid/ListCountFooter';

export interface DocumentsListFooterProps extends ReportFooterProps {
  square?: boolean;
  totalCount?: number;
}

export function DocumentsListFooter({
  square = false,
  totalCount = 0,
  ...reportFooterProps
}: DocumentsListFooterProps): JSX.Element {
  return (
    <>
      <ListCountFooter noun="documents" square={square} totalCount={totalCount} />
      <ReportFooter {...reportFooterProps} />
    </>
  );
}
